/**
 * Get country code used by the `flag-icon-css` framework
 * http://flag-icon-css.lip.is/
 *
 * @param {*} countryCode | string
 * @return string
 */

export default function (countryCode) {
	if (!countryCode) return;

	countryCode = countryCode.toLowerCase();

	if (countryCode == 'ks') {
		countryCode = 'kr';
	} else if (countryCode == 'rp') {
		countryCode = 'ph';
	} else if (countryCode == 'ja') {
		countryCode = 'jp';
	} else if (countryCode == 'cs') {
		countryCode = 'cr';
	} else if (countryCode == 'ho') {
		countryCode = 'hn';
	} else if (countryCode == 'es') {
		countryCode = 'sv';
	} else if (countryCode == 'is') {
		countryCode = 'il';
	} else if (countryCode == 'tu') {
		countryCode = 'tr';
	} else if (countryCode == 'mo') {
		countryCode = 'ma';
	} else if (countryCode == 'as') {
		countryCode = 'au';
	} else if (countryCode == 'td') {
		countryCode = 'tt';
	} else if (countryCode == 'sn') {
		countryCode = 'sg';
	} else if (countryCode == 'pm') {
		countryCode = 'pa';
	} else if (countryCode == 'ch') {
		countryCode = 'cn';
	} else if (countryCode == 'gg') {
		countryCode = 'ge';
	} else if (countryCode == 'dr') {
		countryCode = 'do';
	} else if (countryCode == 'vm') {
		countryCode = 'vn';
	} else if (countryCode == 'sf') {
		countryCode = 'za';
	} else if (countryCode == 'ci') {
		countryCode = 'cl';
	} else if (countryCode == 'r25') {
		countryCode = 'eu';
	} else if (countryCode == 'ni') {
		countryCode = 'ng';
	}

	return countryCode;
}



// WEBPACK FOOTER //
// ./src/js/utilities/get-country-code.js